export const portfolioTypes = {
  PORTFOLIO_IS_LOADING: 'PORTFOLIO_IS_LOADING',
  GET_PORTFOLIO_SUCCESS: 'GET_PORTFOLIO_SUCCESS',
  GET_PORTFOLIO_FAILURE: 'GET_PORTFOLIO_FAILURE',
}
